<template>
<div>
    <h1>Sign in</h1>
    <div style="margin: 20px;"></div>
    <el-form label-position="right" label-width="100px" :model="loginForm" @submit.prevent="login">
        <el-form-item label="Shotgun Login">
            <el-input required v-model="username" placeholder="Shotgun Username"></el-input>
        </el-form-item>
        <el-form-item label="Password">
            <el-input required v-model="password" type="password" placeholder="Password">
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="login">Login</el-button>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
import { AUTH_REQUEST } from "@/store/actions/auth";

export default {
  name: "login",
  data() {
    return {
      loginForm: null,
      username: "",
      password: ""
    };
  },
  methods: {
    login: function() {
      const { username, password } = this;
      this.$store
        .dispatch(AUTH_REQUEST, {
          username,
          password
        })
        .then(() => {
          this.$router.push("/");
        })
        .catch(error => {
          this.username = "";
          this.password = "";
          this.$notify.error({
            title: "Authentication Failed",
            message: "Please verify your login info and try again."
          });
        });
    }
  }
};
</script>

<style>
/* .login {
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 10px;
} */
</style>